var Testimonial = Backbone.NestedModel.extend({

});

var Testimonials = Backbone.Collection.extend({
    model: Testimonial
});

window.aet_testimonials = new Testimonials();
window.aet_testimonials_clone = new Testimonials();